module.exports = __webpack_public_path__ + "img/chevron-right.8ba438a6.svg";